import axios from "./config";

/**
 * @function
 * @name getTrpImplementations
 * @description get general recommendations
 *
 * */
const getTrpImplementations = (packageId, page = 1, perPage = 10, startDate = null, endDate = null) => {
  const params = {
    'filter[package_id]': packageId,
    page: page,
    per_page: perPage,
  };

  if (startDate) {
    params['filter[report_start_date]'] = startDate;
  }
  if (endDate) {
    params['filter[report_end_date]'] = endDate;
  }

  return axios.get('/trps', { params });
};

export default {
  getTrpImplementations,
};
